
const isAnonymous = name => name === 'Anonymous'

export default {
  isAnonymous,
}
